 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"Accesibility~settings":"Accesibility~settings","Accesibility":"Accesibility","settings":"settings","graph":"graph","vr":"vr","privacyPolicy":"privacyPolicy","dashboard":"dashboard","experiment":"experiment","firstView":"firstView","notFound":"notFound","termsOfUse":"termsOfUse","canvg":"canvg","pdfmake":"pdfmake","xlsx":"xlsx"}[chunkId]||chunkId) + "." + {"Accesibility~settings":"1403d50c","Accesibility":"461acf71","chunk-581db3be":"2d9eb4c0","settings":"64d08657","chunk-0bf1dbfe":"d150b041","chunk-0c2c9a22":"61231530","chunk-1227846a":"c23fc101","chunk-1400aefd":"f55eca88","chunk-2f5b31af":"6636bc10","chunk-19bc0f12":"be61f5e7","chunk-1e52639f":"36625271","chunk-228c5846":"20fefeab","chunk-235793e9":"a718b9e3","chunk-23b46d96":"b8d3f7f0","chunk-24900350":"d84397dc","chunk-25d48c52":"c8e0b003","chunk-5405952f":"54be6836","chunk-be88cab4":"a1fec379","graph":"b6a802e2","chunk-2c1f4644":"d98b4d25","chunk-2d0a4d4d":"b2a3061a","chunk-2d221457":"4e6e55a3","chunk-2d3e8788":"87785f16","chunk-445fd6e2":"4cb109c6","chunk-7166445c":"e37a895a","vr":"b5f30de1","chunk-307f34ea":"e8b853e4","chunk-35c9f9bb":"d578bf06","chunk-366edc85":"ff1c3dd3","chunk-385fbe08":"5f08221e","chunk-1d826e88":"efcfb6af","chunk-483df3fa":"bc1731e5","chunk-38e86f7a":"61eba4d0","chunk-39b1a46c":"2e33fe63","chunk-3b18e840":"52bfd361","chunk-3ca39c2a":"32a9f0b8","chunk-41ea0ed2":"6888bb45","chunk-41eec976":"7cd4ab63","chunk-4a8000f7":"0b7b82df","chunk-56c9ff4c":"b64f40a3","chunk-56f5d4ec":"09090dd4","chunk-5aa2a512":"3d344805","chunk-654ee836":"71ab6b16","chunk-6b70a78a":"5222663b","chunk-6ba87c6f":"3f95e1b1","chunk-6d2a3789":"95a6a886","chunk-1e9aea95":"2baca893","chunk-7917b9a5":"0954eb3f","privacyPolicy":"780a48f0","dashboard":"0ce3115b","chunk-2aab1c43":"52c80c9b","chunk-f1f0a78c":"aa585c34","chunk-74d24c3d":"6bde01fe","chunk-7a551b05":"b78adb65","chunk-7a81a18f":"83fad677","chunk-7bf5bffd":"2c691af6","chunk-87104942":"a8c4816f","chunk-8ef6c45a":"d57d48ea","chunk-9ba63a00":"6201ce30","chunk-aaf886b8":"6d6f938b","chunk-b374ce1c":"02947c71","chunk-b7755d8e":"0a7dc7ef","chunk-c09adc58":"406ba1fb","chunk-dd628690":"3efd6014","chunk-184ff7ae":"f366a4c3","experiment":"d550c861","chunk-df2eb44c":"04195b24","chunk-e8f52296":"92f350d7","chunk-ecf20ade":"295ad5b7","chunk-ee5a7d08":"2b8d93a3","chunk-fb63c656":"65045c9c","firstView":"9eb4173d","notFound":"93ab7472","termsOfUse":"2605730a","canvg":"29ab6f69","pdfmake":"7385b4f1","xlsx":"e16493d6"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Accesibility~settings":1,"Accesibility":1,"chunk-581db3be":1,"settings":1,"chunk-0c2c9a22":1,"chunk-1400aefd":1,"chunk-2f5b31af":1,"chunk-19bc0f12":1,"chunk-1e52639f":1,"chunk-228c5846":1,"chunk-235793e9":1,"chunk-24900350":1,"chunk-5405952f":1,"chunk-be88cab4":1,"graph":1,"chunk-2c1f4644":1,"chunk-2d3e8788":1,"chunk-445fd6e2":1,"chunk-7166445c":1,"vr":1,"chunk-307f34ea":1,"chunk-35c9f9bb":1,"chunk-366edc85":1,"chunk-1d826e88":1,"chunk-483df3fa":1,"chunk-38e86f7a":1,"chunk-39b1a46c":1,"chunk-3b18e840":1,"chunk-3ca39c2a":1,"chunk-41ea0ed2":1,"chunk-41eec976":1,"chunk-56c9ff4c":1,"chunk-56f5d4ec":1,"chunk-5aa2a512":1,"chunk-654ee836":1,"chunk-6b70a78a":1,"chunk-6ba87c6f":1,"chunk-6d2a3789":1,"chunk-1e9aea95":1,"chunk-7917b9a5":1,"privacyPolicy":1,"dashboard":1,"chunk-2aab1c43":1,"chunk-f1f0a78c":1,"chunk-74d24c3d":1,"chunk-7a551b05":1,"chunk-7a81a18f":1,"chunk-7bf5bffd":1,"chunk-87104942":1,"chunk-8ef6c45a":1,"chunk-9ba63a00":1,"chunk-aaf886b8":1,"chunk-b374ce1c":1,"chunk-b7755d8e":1,"chunk-c09adc58":1,"chunk-dd628690":1,"chunk-df2eb44c":1,"chunk-e8f52296":1,"chunk-ecf20ade":1,"chunk-ee5a7d08":1,"chunk-fb63c656":1,"firstView":1,"notFound":1,"termsOfUse":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"Accesibility~settings":"Accesibility~settings","Accesibility":"Accesibility","settings":"settings","graph":"graph","vr":"vr","privacyPolicy":"privacyPolicy","dashboard":"dashboard","experiment":"experiment","firstView":"firstView","notFound":"notFound","termsOfUse":"termsOfUse","canvg":"canvg","pdfmake":"pdfmake","xlsx":"xlsx"}[chunkId]||chunkId) + "." + {"Accesibility~settings":"8db331d4","Accesibility":"545fdc9e","chunk-581db3be":"b9519643","settings":"7848016a","chunk-0bf1dbfe":"31d6cfe0","chunk-0c2c9a22":"052e369b","chunk-1227846a":"31d6cfe0","chunk-1400aefd":"7ba0316e","chunk-2f5b31af":"7147b25b","chunk-19bc0f12":"cb378b4a","chunk-1e52639f":"bf05889d","chunk-228c5846":"4cedd4c5","chunk-235793e9":"53334102","chunk-23b46d96":"31d6cfe0","chunk-24900350":"8ecb7062","chunk-25d48c52":"31d6cfe0","chunk-5405952f":"a923d3cb","chunk-be88cab4":"da5cdafd","graph":"0f43ba63","chunk-2c1f4644":"d8c4a4c7","chunk-2d0a4d4d":"31d6cfe0","chunk-2d221457":"31d6cfe0","chunk-2d3e8788":"c4fd20e8","chunk-445fd6e2":"dc85e0fe","chunk-7166445c":"337cb1ab","vr":"2863c78b","chunk-307f34ea":"cd22e89b","chunk-35c9f9bb":"35864e9e","chunk-366edc85":"6db5f2e5","chunk-385fbe08":"31d6cfe0","chunk-1d826e88":"ec5c9519","chunk-483df3fa":"a341af12","chunk-38e86f7a":"b8f23b4a","chunk-39b1a46c":"33ad49f9","chunk-3b18e840":"9bdac20d","chunk-3ca39c2a":"b5834743","chunk-41ea0ed2":"2f695d4f","chunk-41eec976":"65d0ec39","chunk-4a8000f7":"31d6cfe0","chunk-56c9ff4c":"13a35a2d","chunk-56f5d4ec":"4db6d95f","chunk-5aa2a512":"8e655829","chunk-654ee836":"12ebede2","chunk-6b70a78a":"9bdac20d","chunk-6ba87c6f":"f28bc8b3","chunk-6d2a3789":"90cec5c5","chunk-1e9aea95":"c890fb3e","chunk-7917b9a5":"1fa52331","privacyPolicy":"c8ed98a5","dashboard":"b8d7a0e0","chunk-2aab1c43":"02f94612","chunk-f1f0a78c":"1d7d71a3","chunk-74d24c3d":"df2255bb","chunk-7a551b05":"ba6cf481","chunk-7a81a18f":"12b4adf1","chunk-7bf5bffd":"d6349d66","chunk-87104942":"6ba9f83c","chunk-8ef6c45a":"9ba0b6c3","chunk-9ba63a00":"acc72ba2","chunk-aaf886b8":"c9995e3c","chunk-b374ce1c":"e69f686c","chunk-b7755d8e":"6a7e4318","chunk-c09adc58":"45dc2711","chunk-dd628690":"ec9e247a","chunk-184ff7ae":"31d6cfe0","experiment":"31d6cfe0","chunk-df2eb44c":"63b70359","chunk-e8f52296":"a5bf7836","chunk-ecf20ade":"80d695f5","chunk-ee5a7d08":"e7a4c87c","chunk-fb63c656":"4579a90f","firstView":"db775674","notFound":"2a2a990a","termsOfUse":"4e3f1262","canvg":"31d6cfe0","pdfmake":"31d6cfe0","xlsx":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
